import { z } from "zod";
export const withId = ({ required_error, invalid_type_error } = {}) => z.object({
    id: z
        .number({
        required_error,
        invalid_type_error,
    })
        .positive(),
});
